<div class="modal-header">
  <h5 class="modal-title">{{ 'Choose Function' | messageTranslate}}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>

<form (ngSubmit)="onSubmit()">
  <div class="modal-body">
    <div>
      <label for="chosenFunction" class="col-form-label">{{ 'Function' | messageTranslate }}</label>
      <select class="form-control form-select" id="chosenFunction" name="chosenFunction"
              [(ngModel)]="chosenFunctionName" (ngModelChange)="functionChange($event)">
        <option [ngValue]="NONE_FUNCTION.name">{{ NONE_FUNCTION.longNameKey | messageTranslate}}</option>
        @for (chartFunction of chartFunctions; track chartFunction.name) {
          <option [ngValue]="chartFunction.name">
            {{chartFunction.longNameKey | messageTranslate}}
          </option>
        }
      </select>
    </div>

    @if (showTimePeriod) {
      <div class="mt-3">
        <label for="chosenPeriod" class="col-form-label">{{'Time Period' | messageTranslate}}</label>
        <select class="form-control form-select" id="chosenPeriod" name="chosenPeriod" [(ngModel)]="chosenTimePeriod">
          @for (period of periods; track period) {
            <option [ngValue]="period">{{period.text}}</option>
          }
        </select>
      </div>
    }

    @if (chosenFunctionName !== NONE_FUNCTION.name) {
      <div class="mt-3">
        <ui-switch name="chartRawValues" [checked]="chosenChartRawValues" [(ngModel)]="chosenChartRawValues" size="small"/>
        <span class="align-top">{{'Chart Raw Values' | messageTranslate}}</span>
      </div>
    }
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" [disabled]="!chosenFunctionName || !isPeriodSelected()">{{ 'OK' | messageTranslate }}</button>
    <button type="button" ngbAutofocus class="ms-2 btn btn-secondary" (click)="activeModal.dismiss('Cancel')">{{ 'Cancel' | messageTranslate }}</button>
  </div>

</form>
